window.initCitySelect = function(selectElement) {
    if (selectElement && typeof $ !== 'undefined' && $(selectElement).length) {
        // Уничтожаем предыдущую инициализацию
        if ($(selectElement).hasClass('nice-select')) {
            $(selectElement).niceSelect('destroy');
        }

        // Инициализируем niceSelect
        $(selectElement).niceSelect({
            animationSpeed: 0
        });

        // Вешаем обработчик изменения через jQuery
        $(selectElement).on('change', function() {
            const selectedCityId = this.value;
            window.globalState.updateCityId(selectedCityId);
        });

        // Если город уже выбран в globalState, устанавливаем его
        if (window.globalState.cityId) {
            selectElement.value = window.globalState.cityId;
            $(selectElement).niceSelect('update');
        } else {
            // Если город не выбран, но есть опции, устанавливаем первую
            const options = selectElement.options;
            if (options.length > 1) { // >1 потому что первый option может быть пустым
                const firstCityId = options[1].value; // Берем вторую опцию (первая после пустой)
                window.globalState.updateCityId(firstCityId);
                selectElement.value = firstCityId;
                $(selectElement).niceSelect('update');
            } else if (options.length > 0 && options[0].value) {
                // Если нет пустой опции, берем первую
                const firstCityId = options[0].value;
                window.globalState.updateCityId(firstCityId);
                selectElement.value = firstCityId;
                $(selectElement).niceSelect('update');
            }
        }
    }
}